<template>
  <List />
</template>

<script>
import '@telexpress_auth/vue-vms/dist/components/List.css';
import List from '@telexpress_auth/vue-vms/dist/components/List.umd.min';

export default {
  components: {
    List,
  },

};
</script>
